export default __webpack_public_path__ + "static/media/github-tool.2ea07f8a.png";